import React from 'react';
function  SearchBox({searchfield,searchChange}){
    return(<div className="pa2">
            <input className="pa3 ba b--green bg-lightest-blue "
            type="search" placeholder="Seach robots"
            onChange= {searchChange} />
        </div>
            
 
    );

    

}
export default SearchBox;